<div class="fleet-portal">
    <div class="fleet-portal__card">
        <p class="fleet-portal__brand">Resumo · Fleet</p>

        <p *ngIf="error()" data-testid="fleet-portal-error">{{ error() }}</p>
        <p *ngIf="!error() && !portal()">Even laden…</p>

        <ng-container *ngIf="portal() as p">
            <h1>Documenten voor {{ p.licensePlate }}</h1>
            <p *ngIf="p.vehicleModel" class="fleet-portal__model">{{ p.vehicleModel }}</p>

            <p *ngIf="p.completed" data-testid="fleet-portal-complete">Bedankt{{ p.driverFirstName ? ', ' + p.driverFirstName : '' }}! Alle gevraagde documenten zijn ontvangen.</p>
            <p *ngIf="!p.completed && p.expired" data-testid="fleet-portal-expired">Deze link is verlopen. Vraag je fleetbeheerder om een nieuwe.</p>

            <ng-container *ngIf="!p.completed && !p.expired">
                <p>Dag{{ p.driverFirstName ? ' ' + p.driverFirstName : '' }}, laad hieronder de ontbrekende documenten op. Een PDF of een duidelijke foto (JPG of PNG) volstaat.</p>
            </ng-container>

            <ul class="fleet-portal__list">
                <li *ngFor="let document of p.documents" [attr.data-testid]="'fleet-portal-doc-' + document.type">
                    <span class="fleet-portal__status" [class.fleet-portal__status--ok]="document.uploaded">{{ document.uploaded ? '✔' : '✘' }}</span>
                    <span class="fleet-portal__label">{{ document.label }}</span>
                    <label *ngIf="!document.uploaded && !p.completed && !p.expired" class="button button--small">
                        {{ uploading() === document.type ? 'Bezig…' : 'Opladen' }}
                        <input
                            type="file"
                            accept="application/pdf,image/jpeg,image/png"
                            hidden
                            [disabled]="uploading() !== null"
                            [attr.data-testid]="'fleet-portal-input-' + document.type"
                            (change)="onFileSelected(document, $event)" />
                    </label>
                    <small *ngIf="document.uploaded">ontvangen</small>
                </li>
            </ul>

            <p *ngIf="uploadError()" class="fleet-portal__error" data-testid="fleet-portal-upload-error">{{ uploadError() }}</p>
        </ng-container>
    </div>
</div>
